import { useNavigate } from "react-router";
import { StandardButton } from "./standardButton";
import { useCallback } from "react";
import circleWithCheck from "../resources/circleWithCheck.svg";
import * as motion from "motion/react-client";
import { isMobile } from "react-device-detect";

export const PricingOption = ({
  link,
  features,
  name,
  price,
  buttonColor,
  buttonTextColor,
  buttonShift
}: {
  link: string;
  features: string[];
  name: string;
  price: string;
  buttonColor: string,
  buttonTextColor: string,
  buttonShift: number
}) => {
  const nav = useNavigate();
  const goToLink = useCallback(() => {
    nav(link);
  }, [nav, link]);
  return (
    <motion.div
      style={{
        borderRadius: 16,
        width: isMobile ? "80%" : "20rem",
        boxShadow:
          "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)",
        padding: isMobile ? 20 : 30,
        backgroundColor: "white",
        margin: isMobile ? "0 auto" : undefined, // center on mobile if you want
      }}
      // Disable or modify hover effect on mobile
      whileHover={
        !isMobile
          ? {
              scale: 1.05,
              boxShadow:
                "0 6px 8px rgba(0, 0, 0, 0.15), 0 3px 4px rgba(0, 0, 0, 0.10)",
            }
          : {}
      }
    >
      <div style={{ color: "#BCBCBC", fontSize: isMobile ? "0.95rem" : "1rem" }}>
        {name}
      </div>
      <div
        style={{
          marginTop: isMobile ? "1rem" : "1.5rem",
          marginBottom: isMobile ? "1rem" : "2rem",
        }}
      >
        <span
          style={{
            fontSize: isMobile ? "2rem" : "2.5rem",
            fontWeight: 700,
          }}
        >
          ${price}
        </span>
        <span>/month</span>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          marginBottom: "1rem",
        }}
      >
        {features.map((feature, index) => (
          <div key={index} style={{ display: "flex", alignItems: "center" }}>
            <img src={circleWithCheck} alt="Feature check icon" />
            <span style={{ marginLeft: ".5rem" }}>{feature}</span>
          </div>
        ))}
      </div>
      <div style={{height: `${buttonShift}rem`}} />

      <StandardButton
        buttonText="Start For Free"
        onClick={goToLink}
        buttonColor={buttonColor}
        customStyles={{ color: buttonTextColor, fontWeight: 500 }}
      />
    </motion.div>
  );
};
